import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminServiceAccountsComponent } from './admin-service-accounts.component';

const routes: Routes = [
  {
    path: '',
    component: AdminServiceAccountsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminServiceAccountsRoutingModule {}
